import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import ContactHeader from "../../components/Header/ContactHeader";
import Footer from "../../components/Footer";
import Scroll from "../Header/Scroll";
import Banner from "./components/Banner";
import About from "./components/About";
import Framework from "./components/Framework";
import Conviction from "./components/Conviction";
import Partners from "./components/Partners";
import Blog from "./components/Blog";
import Image2 from "../../assets/banner/banner1.jpg";

const styles = {
  paperContainer: {
    height: 800,
    backgroundImage: `url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Home = () => {
  return (
    <Box>
      <Helmet>
        <title> Homepage | Aquatic Hub Afrique</title>
      </Helmet>
      <Box
        bgcolor={"#194ec3"}
        position={"relative"}
        display={{ xs: "none", sm: "block" }}
      >
        <ContactHeader />
      </Box>
      <Scroll>
        <AppBar position={"sticky"} elevation={0} padding={"10px 0px"}>
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box display={{ xs: "none", sm: "inline" }}>
        <Banner />
      </Box>
      <Box style={styles.paperContainer} display={{ xs: "block", sm: "none" }}>
        <Banner />
      </Box>
      <Box>
        <Container>
          <About />
        </Container>
      </Box>
      <Box bgcolor={"#F4F9FF"}>
        <Container>
          <Framework />
        </Container>
      </Box>
      <Box bgcolor={""}>
        <Container>
          <Conviction />
        </Container>
      </Box>
      <Box>
        <Container>
          <Partners />
        </Container>
      </Box>
      <Box>
        <Container>
          <Blog />
        </Container>
      </Box>
      <Box bgcolor={"#000058"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
